// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3AF_c","rotateTransform":"styles_rotateTransform__kIvF8","greenTextStyle":"styles_greenTextStyle__erMCl","redTextStyle":"styles_redTextStyle__2-jM0"};